import React from "react";

/**
 * Renders a shortcut description with each `[X]`-marked letter emphasised,
 * showing the visual link between the description and the key on the right
 * (e.g. "[N]ew task" → **N**ew task, paired with the `N` key).
 *
 * The bracket markers live in the data layer (`src/lib/shortcuts.ts`); this
 * component just parses them.
 */
const ShortcutDescription: React.FC<{ text: string }> = ({ text }) => {
  const parts = text.split(/(\[[^\]]+\])/g);
  return (
    <>
      {parts.map((part, i) => {
        if (part.startsWith("[") && part.endsWith("]")) {
          return (
            <strong
              key={i}
              className="font-bold text-warm-blue underline underline-offset-2"
            >
              {part.slice(1, -1)}
            </strong>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </>
  );
};

export default ShortcutDescription;
